var render = function () {
  var _vm$giftOrder, _vm$giftOrder2, _vm$giftOrder3, _vm$giftOrder4, _vm$giftOrder5, _vm$giftOrder6, _vm$giftOrder7, _vm$giftOrder7$purcha, _vm$giftOrder8, _vm$giftOrder8$buyer, _vm$giftOrder9, _vm$giftOrder9$buyer, _vm$giftOrder10, _vm$giftOrder10$buyer, _vm$giftOrder11, _vm$giftOrder11$buyer, _vm$giftOrder12, _vm$giftOrder12$shipp, _vm$giftOrder13, _vm$giftOrder13$shipp, _vm$giftOrder14, _vm$giftOrder14$shipp, _vm$giftOrder15, _vm$giftOrder15$shipp, _vm$giftOrder16, _vm$giftOrder16$recei;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_vm.ready && _vm.giftOrder ? _c('div', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("선물결과")])]), _c('div', {
    staticClass: "contents-area__inner"
  }, [_c('section', {
    staticClass: "page-section pt-0"
  }, [_vm.resCode === '3001' ? _c('v-data-table', {
    staticClass: "d-flex purchasedetail-table",
    attrs: {
      "items": _vm.purchases,
      "headers": _vm.purchasesHeaders,
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "mobile-breakpoint": "768",
      "width": "100%"
    },
    scopedSlots: _vm._u([{
      key: "item.product",
      fn: function fn(_ref) {
        var _item$product;

        var item = _ref.item;
        return [_c('div', {
          staticClass: "img-wrap border"
        }, [_c('router-link', {
          attrs: {
            "to": "/shop/products/".concat(item.product._mainProduct || item.product._id)
          }
        }, [_c('v-img', {
          attrs: {
            "src": item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.thumb,
            "width": "100",
            "aspect-ratio": 1 / 1,
            "contain": ""
          }
        })], 1)], 1)];
      }
    }, {
      key: "item.name",
      fn: function fn(_ref2) {
        var _item$product2;

        var item = _ref2.item;
        return _c('v-responsive', {}, [_c('v-flex', [_c('router-link', {
          attrs: {
            "to": "/shop/products/".concat(item.product._mainProduct || item.product._id)
          }
        }, [_c('div', {
          staticClass: "mx-2 text-truncate"
        }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.name))])])], 1)], 1);
      }
    }, {
      key: "item.saleAmount",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return _c('v-responsive', {}, [_c('v-flex', [_c('div', {
          staticClass: "mx-2 text-truncate"
        }, [_vm._v(_vm._s(item.saleAmount.format()) + "원")])])], 1);
      }
    }, {
      key: "item.earnPointAmount",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return _c('v-responsive', {}, [_c('v-flex', [_c('div', {
          staticClass: "mx-2 text-truncate"
        }, [_vm._v(_vm._s(item.earnPointAmount.format()) + "원")])])], 1);
      }
    }], null, false, 169807661)
  }) : _c('div', [_c('div', [_vm._v("[" + _vm._s(_vm.resCode) + "]")]), _c('div', [_vm._v("결제가 완료되지 않았습니다")])])], 1), _c('section', {
    staticClass: "page-section py-0"
  }, [_c('div', {
    staticClass: "card--primary"
  }, [_c('v-row', {
    staticClass: "row--x-small font-size-14 font-size-md-16",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("상품("), _c('b', [_vm._v(_vm._s(((_vm$giftOrder = _vm.giftOrder) === null || _vm$giftOrder === void 0 ? void 0 : _vm$giftOrder.saleAmount.format()) || 0) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("+")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("배송비("), _c('b', [_vm._v(_vm._s(((_vm$giftOrder2 = _vm.giftOrder) === null || _vm$giftOrder2 === void 0 ? void 0 : _vm$giftOrder2.shippingAmount.format()) || 0) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("적립금 사용("), _c('b', [_vm._v(_vm._s(((_vm$giftOrder3 = _vm.giftOrder) === null || _vm$giftOrder3 === void 0 ? void 0 : _vm$giftOrder3.pointAmount.format()) || 0) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("캐시 사용("), _c('b', [_vm._v(_vm._s(((_vm$giftOrder4 = _vm.giftOrder) === null || _vm$giftOrder4 === void 0 ? void 0 : _vm$giftOrder4.cashAmount.format()) || 0) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("=")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', [_vm._v("총 결제 금액")]), _c('b', {
    staticClass: "font-size-20 font-size-md-24 ml-10px ml-md-12px"
  }, [_vm._v(_vm._s(_vm.totalAmount.format()) + "원")])])])], 1)], 1)]), _c('section', {
    staticClass: "page-section"
  }, [_c('table', {
    staticClass: "table--default"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]), _c('tr', [_c('th', [_vm._v("주문번호")]), _c('td', [_vm._v(_vm._s((_vm$giftOrder5 = _vm.giftOrder) === null || _vm$giftOrder5 === void 0 ? void 0 : _vm$giftOrder5.orderNo))]), _c('th', [_vm._v("주문일")]), _c('td', [_vm._v(_vm._s((_vm$giftOrder6 = _vm.giftOrder) === null || _vm$giftOrder6 === void 0 ? void 0 : _vm$giftOrder6.createdAt.toDate()))])]), _c('tr', [_c('th', [_vm._v("결제방법")]), _c('td', [_vm._v(_vm._s(_vm.paymentWay))]), _c('th', [_vm._v("주문상태")]), _c('td', [_vm._v(_vm._s((_vm$giftOrder7 = _vm.giftOrder) === null || _vm$giftOrder7 === void 0 ? void 0 : (_vm$giftOrder7$purcha = _vm$giftOrder7.purchases) === null || _vm$giftOrder7$purcha === void 0 ? void 0 : _vm$giftOrder7$purcha.paymentStatus))])]), _c('tr', [_c('th', [_vm._v("입금자명")]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s((_vm$giftOrder8 = _vm.giftOrder) === null || _vm$giftOrder8 === void 0 ? void 0 : (_vm$giftOrder8$buyer = _vm$giftOrder8.buyer) === null || _vm$giftOrder8$buyer === void 0 ? void 0 : _vm$giftOrder8$buyer.name))])])])]), _c('section', {
    staticClass: "page-section pb-0"
  }, [_c('div', {
    staticClass: "tit-wrap mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("주문하신 분")])]), _c('table', {
    staticClass: "table--default"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "80%"
    }
  })]), _c('tr', [_c('th', [_vm._v("주문하신분")]), _c('td', [_vm._v(_vm._s((_vm$giftOrder9 = _vm.giftOrder) === null || _vm$giftOrder9 === void 0 ? void 0 : (_vm$giftOrder9$buyer = _vm$giftOrder9.buyer) === null || _vm$giftOrder9$buyer === void 0 ? void 0 : _vm$giftOrder9$buyer.name))])]), _c('tr', [_c('th', [_vm._v("연락처")]), _c('td', [_vm._v(_vm._s((_vm$giftOrder10 = _vm.giftOrder) === null || _vm$giftOrder10 === void 0 ? void 0 : (_vm$giftOrder10$buyer = _vm$giftOrder10.buyer) === null || _vm$giftOrder10$buyer === void 0 ? void 0 : _vm$giftOrder10$buyer.phone))])]), _c('tr', [_c('th', [_vm._v("이메일")]), _c('td', [_vm._v(_vm._s((_vm$giftOrder11 = _vm.giftOrder) === null || _vm$giftOrder11 === void 0 ? void 0 : (_vm$giftOrder11$buyer = _vm$giftOrder11.buyer) === null || _vm$giftOrder11$buyer === void 0 ? void 0 : _vm$giftOrder11$buyer.email))])]), _c('tr', [_c('th', [_vm._v("주소")]), (_vm$giftOrder12 = _vm.giftOrder) !== null && _vm$giftOrder12 !== void 0 && (_vm$giftOrder12$shipp = _vm$giftOrder12.shippingAddress) !== null && _vm$giftOrder12$shipp !== void 0 && _vm$giftOrder12$shipp.postcode ? _c('td', [_vm._v(_vm._s("[".concat((_vm$giftOrder13 = _vm.giftOrder) === null || _vm$giftOrder13 === void 0 ? void 0 : (_vm$giftOrder13$shipp = _vm$giftOrder13.shippingAddress) === null || _vm$giftOrder13$shipp === void 0 ? void 0 : _vm$giftOrder13$shipp.postcode, "] ").concat((_vm$giftOrder14 = _vm.giftOrder) === null || _vm$giftOrder14 === void 0 ? void 0 : (_vm$giftOrder14$shipp = _vm$giftOrder14.shippingAddress) === null || _vm$giftOrder14$shipp === void 0 ? void 0 : _vm$giftOrder14$shipp.address1, " ").concat((_vm$giftOrder15 = _vm.giftOrder) === null || _vm$giftOrder15 === void 0 ? void 0 : (_vm$giftOrder15$shipp = _vm$giftOrder15.shippingAddress) === null || _vm$giftOrder15$shipp === void 0 ? void 0 : _vm$giftOrder15$shipp.address2)))]) : _c('td')]), _c('tr', [_c('th', [_vm._v("받는사람 연락처")]), _c('td', [_vm._v(_vm._s((_vm$giftOrder16 = _vm.giftOrder) === null || _vm$giftOrder16 === void 0 ? void 0 : (_vm$giftOrder16$recei = _vm$giftOrder16.receiver) === null || _vm$giftOrder16$recei === void 0 ? void 0 : _vm$giftOrder16$recei.phone))])])])]), _c('div', {
    staticClass: "mt-20px mt-md-30px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "outlined": "",
      "color": "gray",
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "grey--text text--darken-3"
  }, [_vm._v("홈으로가기")])])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "to": "/mypage/shop/purchases"
    }
  }, [_vm._v("주문배송확인")])], 1)], 1)], 1)])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }